import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Paper, List, Subheader, IconButton, Divider, FlatButton, Dialog } from 'material-ui';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { white } from 'material-ui/styles/colors';
import style from '../../../styles/styles';
import Loading from '../../common/Loading/Loading';
import withTranslation from '../../../hoc/withTranslation';
import { ADD_ACCESS_TOKEN_PAGE } from '../../../constants/routes';
import Error from '../Error/Error';
import AccessTokenList from './AccessTokenList';
import { deleteAccessToken, getAccessTokens } from '../../../store/accessTokens/actions';

class AccessTokenSetting extends React.Component {
    static propTypes = {
        app: PropTypes.object,
        accessTokens: PropTypes.array,
        deleteAccessToken: PropTypes.func,
        getAccessTokens: PropTypes.func,
        sending: PropTypes.bool,
    };

    static defaultProps = {
        app: null,
        loading: false,
        accessTokens: [],
    };
    state = {
        accessTokenToRemove: null,
        openRemoveAccessToken: false,
    };

    componentWillMount() {
        this.props.getAccessTokens(this.props.app.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.accessTokenError === null) {
            if (this.state.accessTokenToRemove) {
                try {
                    this.handleCloseAccessToken();
                } catch (e) {
                    console.error(e);
                }
            }
        }
    }

    handleDeleteAccessToken = (accessToken) => {
        this.setState({
            openRemoveAccessToken: true,
            accessTokenToRemove: accessToken,
        });
    };

    handleCloseAccessToken = () => {
        this.setState({
            openRemoveAccessToken: false,
            accessTokenToRemove: null,
        });
    };

    deleteAccessToken = () => {
        this.props.deleteAccessToken(this.props.app.id, this.state.accessTokenToRemove.id);
        this.handleCloseAccessToken();
    };

    renderDeleteAccessTokensDialog(accessToken) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseAccessToken}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteAccessToken}
            />,
        ];
        return (
            <Dialog
                actions={actions}
                modal={this.props.sending}
                open={this.state.openRemoveAccessToken}
                onRequestClose={this.handleCloseAccessToken}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <div
                        dangerouslySetInnerHTML={{
                            __html:
                                this.props.t(
                                    'settings_page.remove_access_token_confirmation',
                                    { name: accessToken.name },
                                ),
                        }}
                    />
                }
            </Dialog>
        );
    }

    render() {
        const {
            loading,
            app,
            user,
            accessTokens,
        } = this.props;

        let content;
        if (loading) {
            content = <Loading paper={false} />;
        } else if (accessTokens.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('generic.add_some_element')}
                />;
        } else {
            content = accessTokens.map((accessToken, index) => {
                return (
                    <div key={accessToken.id}>
                        <AccessTokenList
                            app={app}
                            accessToken={accessToken}
                            user={user}
                            handleRemoveAccessToken={this.handleDeleteAccessToken}
                        />
                        {index !== (
                            accessTokens.length - 1
                        ) && <Divider inset={true} />}
                    </div>

                );
            });
        }

        return (
            <div>
                {this.state.accessTokenToRemove
                    && this.renderDeleteAccessTokensDialog(this.state.accessTokenToRemove)}
                <Paper>
                    <List>
                        <Subheader style={{ ...style.subHeader, ...style.relative }}>
                            {this.props.t('module.access_token.name')}
                            <Link to={ADD_ACCESS_TOKEN_PAGE.replace(':appId', this.props.app.id)}>
                                <IconButton
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_element')}
                                    tooltipPosition="top-center"
                                >
                                    <ContentAdd color={white} />
                                </IconButton>
                            </Link>
                        </Subheader>
                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        app: state.apps.currentApplication,
        user: state.auth.content,
        sending: state.accessTokens.sending,
        accessTokenError: state.accessTokens.error,
    };
}

export default connect(
    mapStateToProps,
    {
        deleteAccessToken,
        getAccessTokens,
    },
)(withTranslation(AccessTokenSetting));



// WEBPACK FOOTER //
// src/components/common/AccessTokenSetting/AccessTokenSetting.js